import { adminHttpClient } from '../../commons/adminHttpClient'

export type ExpenseForUpdate = {
  name?: string
  description?: string
  requestedAmount?: number
  serviceProvider?: string
  expenseTypeId?: number
  expenseCategoryId?: number
  purchasedDate: string
  attachments?: ExpenseForUpdateAttachments[]
}

export type ExpenseForUpdateAttachments = {
  fileNameUrl: string
  id: string
  reuseInOtherExpenses: boolean
  title: string
}

export const getExpenseForUpdate = (expenseID: string): Promise<ExpenseForUpdate> => {
  console.log(expenseID)
  return adminHttpClient.get(`/EEDashboard/Perks/GetExpenseForUpdate/${expenseID}`, {})
}
